import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import { featuredWorkflowInfo } from "./FeaturedWorkflow/FeaturedWorkflowInfo";
import React from "react";
import { FeaturedBadge } from "../Stickers/MarketplaceCard";
import { Element } from "react-scroll";

const MainContainer = styled("div")({
  width: "99%",
  height: "350px",
  color: "white",
  boxSizing: "border-box",
  position: "relative",
  marginTop: "1rem",
  borderRadius: "7px",
  overflow: "hidden",
  textAlign: "left",
  "@media (max-width: 650px)": {
    display: "none",
  },
});

const FeaturedImage = styled("div")({
  width: "100%",
  height: "100%",
  position: "absolute",
  backgroundSize: "cover",
  top: 0,
  left: 0,
  backgroundImage: 'url("images/featured.jpg")',
  zIndex: 0,
});

const InfoContainer = styled("div")({
  height: "90%",
  maxWidth: "700px",
  display: "flex",
  flexDirection: "column",
  zIndex: 3,
  position: "absolute",
  marginLeft: "2rem",
  marginTop: "2rem",
  padding: "12px",
});

const Heading = styled("h3")({
  color: "white",
  fontWeight: "bold !important",
  marginBottom: "0px",
});

const Description = styled("p")({
  maxHeight: "120px",
  width: "100%",
});

const Link = styled("a")({
  textDecoration: "none",
});

const StyledButton = styled(Button)({
  backgroundColor: "white",
  width: "155px",
  color: "black",
  border: "1px solid black",
  ":hover": {
    border: "1px solid #0288d1",
    backgroundColor: "white",
    color: "#0288d1",
  },
});

const { templateName, templateDescription, href } = featuredWorkflowInfo;

/**
 *
 * @returns Banner for the featured template. You can change its details on FeaturedWorkflowInfo.js
 */
const FeaturedBanner = () => {
  return (
    <MainContainer>
      <Element name="featuredTemplate" />
      <FeaturedImage />
      <InfoContainer>
        <FeaturedBadge width="100px" />
        <Heading>{templateName}</Heading>
        <Description>{templateDescription}</Description>
        <Link href={href} />
        <StyledButton
          target="_blank"
          href={href}
          variant="outlined"
          color="info"
        >
          Download
        </StyledButton>
      </InfoContainer>
    </MainContainer>
  );
};

export default FeaturedBanner;
